// extracted by mini-css-extract-plugin
export var label = "_e4-2";
export var slideContainer = "_e4-0";
export var slider = "_e4-1";